module.exports = {
    'music/嘀嗒嘀.mp3': require('!arraybuffer-loader!./assets/music/嘀嗒嘀.mp3'),
    'music/叮铃铃.mp3': require('!arraybuffer-loader!./assets/music/叮铃铃.mp3'),
    'music/呵呵呵.mp3': require('!arraybuffer-loader!./assets/music/呵呵呵.mp3'),
    'music/正确.mp3': require('!arraybuffer-loader!./assets/music/正确.mp3'),
    'music/水滴.mp3': require('!arraybuffer-loader!./assets/music/水滴.mp3'),
    'music/欢呼.mp3': require('!arraybuffer-loader!./assets/music/欢呼.mp3'),
    'music/嗯？.mp3': require('!arraybuffer-loader!./assets/music/嗯？.mp3'),
    'instruments/20-synth-lead/60.mp3': require('!arraybuffer-loader!../scratch3_music/assets/instruments/20-synth-lead/60.mp3'),
};
